import { useState } from 'react';

import Configure from 'assets/unifiedCommunication/Configure.svg';
import Button from 'common-ui/button';
import MyCheckbox from 'common-ui/myCheckbox';
import Switch from 'common-ui/switch';
import { Table } from 'common-ui/table';

import ChannelConfigurator from '../components/ChannelConfigurator';
import { ConfigureButton, SearchButton, StatusWrapper, TableWrapper } from './ByUser.styles';
import { Filter } from './Filter';

const ByUser = () => {
  const [active, setActive] = useState(false);

  const initialData = [
    {
      id: 1,
      fullName: 'John Smith',
      email: 'john@mail.com',
      occupation: 'Designer',
      role: 'Admin',
      viewAccess: false,
      viewReply: true,
      status: 'Active',
    },
    {
      id: 2,
      fullName: 'Anna Brown',
      email: 'anna@mail.com',
      occupation: 'Developer',
      role: 'Manager',
      viewAccess: true,
      viewReply: false,
      status: 'Disabled',
    },
  ];

  const [tableData, setTableData] = useState(initialData);
  const [isChannelModalOpen, setIsChannelModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [channelPermissions, setChannelPermissions] = useState({});

  const handleCheckboxChange = (rowId, field) => {
    setTableData((prev) =>
      prev.map((item) => (item.id === rowId ? { ...item, [field]: !item[field] } : item))
    );
  };

  const handleToggleStatus = (id) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, status: item.status === 'Active' ? 'Disabled' : 'Active' }
          : item
      )
    );
  };

  const columns = [
    {
      key: 'fullName',
      title: 'Full Name',
      dataIndex: 'fullName',
    },
    {
      key: 'email',
      title: 'Email',
      dataIndex: 'email',
    },
    {
      key: 'occupation',
      title: 'Occupation',
      dataIndex: 'occupation',
    },
    {
      key: 'role',
      title: 'Role',
      dataIndex: 'role',
    },
    {
      key: 'viewAccess',
      title: 'View Access',
      dataIndex: 'viewAccess',
      render: (value, row) => (
        <MyCheckbox
          id={`viewAccess-${row.id}`}
          selected={value}
          onClick={() => handleCheckboxChange(row.id, 'viewAccess')}
        />
      ),
    },
    {
      key: 'viewReply',
      title: 'View and Reply',
      dataIndex: 'viewReply',
      render: (value, row) => (
        <MyCheckbox
          id={`viewReply-${row.id}`}
          selected={value}
          onClick={() => handleCheckboxChange(row.id, 'viewReply')}
        />
      ),
    },
    {
      key: 'channels',
      title: 'Channels',
      render: (_, row) => (
        <ConfigureButton
          onClick={() => {
            setSelectedUser(row);
            setIsChannelModalOpen(true);
          }}
        >
          <img src={Configure} alt="configure" />
          Configure
        </ConfigureButton>
      ),
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (value, row) => {
        const isActive = value === 'Active';
        return (
          <StatusWrapper isActive={isActive}>
            <p>{value}</p>
            <Switch
              activeColor="#15C7A7"
              isOn={isActive}
              onToggle={() => handleToggleStatus(row.id)}
            />
          </StatusWrapper>
        );
      },
    },
  ];

  return (
    <div>
      <SearchButton>
        <div>
          <Button
            active={active}
            onClick={() => setActive(!active)}
            className="action-button"
            variant={'search'}
          >
            Search
          </Button>
        </div>
      </SearchButton>

      {active && <Filter />}

      <TableWrapper>
        <Table data={tableData} columns={columns} pagination={false} />
      </TableWrapper>

      {selectedUser && (
        <ChannelConfigurator
          isOpen={isChannelModalOpen}
          onClose={() => setIsChannelModalOpen(false)}
          team={selectedUser}
          channelPermissions={channelPermissions}
          setChannelPermissions={setChannelPermissions}
        />
      )}
    </div>
  );
};

export default ByUser;
